import React from 'react'
import Head from "next/head"

const MetaTagHeader = () => {
  const title = `Danh sách Bất động sản đầu tư chung`
  const desc = `Danh sách các căn hộ đang được đầu tư chung. Chỉ từ 20 triệu đồng 1 phần.`
  return (
    <Head>
      <title>{title}</title>
      <meta name='description' content={desc} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
    </Head>
  )
}
export default MetaTagHeader
